import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"barbecue"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M14.0233 3.50281C14.6937 2.8324 15.7807 2.8324 16.4511 3.50281L20.4974 7.54909C21.1678 8.2195 21.1678 9.30645 20.4974 9.97686L19.2835 11.1907C18.6131 11.8612 17.5261 11.8612 16.8557 11.1907L12.8094 7.14446C12.139 6.47405 12.139 5.3871 12.8094 4.71669L14.0233 3.50281Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M10.3817 7.14441C11.0521 6.474 12.1391 6.474 12.8095 7.14441L16.8558 11.1907C17.5262 11.8611 17.5262 12.9481 16.8558 13.6185L15.6419 14.8323C14.9715 15.5028 13.8845 15.5028 13.2141 14.8323L9.16785 10.7861C8.49744 10.1157 8.49744 9.0287 9.16785 8.35829L10.3817 7.14441Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6.73964 10.786C7.41005 10.1156 8.497 10.1156 9.16741 10.786L13.2137 14.8323C13.8841 15.5027 13.8841 16.5897 13.2137 17.2601L11.9998 18.4739C11.3294 19.1444 10.2424 19.1444 9.57204 18.4739L5.52576 14.4277C4.85535 13.7573 4.85535 12.6703 5.52576 11.9999L6.73964 10.786Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.54909 16.4512L5.93058 18.0697C5.26017 17.3993 4.17322 17.3993 3.50281 18.0697C2.8324 18.7401 2.8324 19.827 3.50281 20.4975C3.98561 20.9803 4.68445 21.1154 5.28817 20.9028M20.0926 3.90723L17.5 6.49979M12.8094 7.14446L16.8557 11.1907C17.5261 11.8612 18.6131 11.8612 19.2835 11.1907L20.4974 9.97686C21.1678 9.30645 21.1678 8.2195 20.4974 7.54909L16.4511 3.50281C15.7807 2.8324 14.6937 2.8324 14.0233 3.50281L12.8094 4.71669C12.139 5.3871 12.139 6.47405 12.8094 7.14446ZM12.8095 7.14441L16.8558 11.1907C17.5262 11.8611 17.5262 12.9481 16.8558 13.6185L15.6419 14.8323C14.9715 15.5028 13.8845 15.5028 13.2141 14.8323L9.16785 10.7861C8.49744 10.1157 8.49744 9.0287 9.16785 8.35829L10.3817 7.14441C11.0521 6.474 12.1391 6.474 12.8095 7.14441ZM9.16741 10.786L13.2137 14.8323C13.8841 15.5027 13.8841 16.5897 13.2137 17.2601L11.9998 18.4739C11.3294 19.1444 10.2424 19.1444 9.57204 18.4739L5.52576 14.4277C4.85535 13.7573 4.85535 12.6703 5.52576 11.9999L6.73964 10.786C7.41005 10.1156 8.497 10.1156 9.16741 10.786Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Barbecue = Vue.extend<IconProps>({
  name: 'BarbecueIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'barbecue',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Barbecue;
